// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-patients-card-container {
    border: 1px solid rgba(255, 255, 255, 0.5);
    padding: 24px 15px;
    border-radius: 12px;
    background-color: var(--darkGreen);
}

.my-patients-card-container .top-view {
    display: flex;
    text-align: left;
}

.my-patients-card-container .top-view .user-name {
    font-weight: 400;
    color: var(--primeryColor);
}

.my-patients-card-container .top-view .address {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
}

.user-info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--lightBlack);
    border-radius: 10px;
    padding: 11px 16px;
    margin-top: 24px;
}

.user-info-box .title {
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 400;
}

.user-info-box .sub-title {
    color: var(--primeryColor);
    font-weight: 400;
    margin-top: 4px;
}

.user-image-box {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.user-initials {
    font-size: 40px;
    color: black;
}

.patents-details-wrapper .user-info-box {
    background-color: transparent;
    border: 1px dashed var(--whiteLight);
}

.border-dotted {
    border-right: 0.5px dotted rgba(255, 255, 255, 0.5);
    height: 48px;
}

.goal-set-box {
    text-align: left;
    border-bottom: 1px dotted;
    border-color: rgba(255, 255, 255, 0.5);
    padding-bottom: 14px;
}

.goal-set-box .title {
    font-size: 14px;
    font-family: 'Maitree';
    color: var(--primeryColor);
}

.goal-set-box .sub-title {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 3px;
}

.card-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 17px;
    text-align: left;
    align-items: center;
    gap: 10px;
}

.card-footer .title {
    color: var(--primeryColor);
    font-size: 14px;
    font-family: 'Maitree';
}

.card-footer .sub-title {
    margin: 5px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
}

.profile-btn button {
    color: rgba(255, 255, 255, 0.5);
    border-color: rgba(255, 255, 255, 0.5);
    border-radius: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/Screens/MyPatients/components/PatientDetailsCard/styles.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,mDAAmD;IACnD,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,sCAAsC;IACtC,mBAAmB;AACvB","sourcesContent":[".my-patients-card-container {\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    padding: 24px 15px;\n    border-radius: 12px;\n    background-color: var(--darkGreen);\n}\n\n.my-patients-card-container .top-view {\n    display: flex;\n    text-align: left;\n}\n\n.my-patients-card-container .top-view .user-name {\n    font-weight: 400;\n    color: var(--primeryColor);\n}\n\n.my-patients-card-container .top-view .address {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.user-info-box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: var(--lightBlack);\n    border-radius: 10px;\n    padding: 11px 16px;\n    margin-top: 24px;\n}\n\n.user-info-box .title {\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.user-info-box .sub-title {\n    color: var(--primeryColor);\n    font-weight: 400;\n    margin-top: 4px;\n}\n\n.user-image-box {\n    width: 75px;\n    height: 75px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.user-initials {\n    font-size: 40px;\n    color: black;\n}\n\n.patents-details-wrapper .user-info-box {\n    background-color: transparent;\n    border: 1px dashed var(--whiteLight);\n}\n\n.border-dotted {\n    border-right: 0.5px dotted rgba(255, 255, 255, 0.5);\n    height: 48px;\n}\n\n.goal-set-box {\n    text-align: left;\n    border-bottom: 1px dotted;\n    border-color: rgba(255, 255, 255, 0.5);\n    padding-bottom: 14px;\n}\n\n.goal-set-box .title {\n    font-size: 14px;\n    font-family: 'Maitree';\n    color: var(--primeryColor);\n}\n\n.goal-set-box .sub-title {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.5);\n    margin-top: 3px;\n}\n\n.card-footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 17px;\n    text-align: left;\n    align-items: center;\n    gap: 10px;\n}\n\n.card-footer .title {\n    color: var(--primeryColor);\n    font-size: 14px;\n    font-family: 'Maitree';\n}\n\n.card-footer .sub-title {\n    margin: 5px;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 12px;\n}\n\n.profile-btn button {\n    color: rgba(255, 255, 255, 0.5);\n    border-color: rgba(255, 255, 255, 0.5);\n    border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
